import { useState } from "react";



const Accordion = () => {
    const [OpenItem, setOpenItem] = useState(null);


    const handleItemClick = (itemId) => {
        setOpenItem(OpenItem === itemId ? null : itemId);
    };

    const AccordionData = [
        {
            id: "heading1",
            title: "Our Mission",
            content: "To empower organizations by delivering scalable, secure, and future-ready technology solutions that drive business transformation."
        },
        {
            id: "heading2",
            title: "Our Vision",
            content: "To be a global leader in technology consulting and services, helping businesses thrive in the ever-changing digital landscape."
        },
        {
            id: "heading3",
            title: "What We Do",
            content: "We provide end-to-end services including Cloud Technologies, Software Development, IT Consulting, and Enterprise Solutions, tailored to meet the needs of startups and enterprises alike."
        },
        
    ]


    return (
        <div className="accordion">
            {AccordionData.map((item =>
                <div className="accordion-item" key={item.id} >
                    <h3 className="accordion-header" id={item.id}>
                        <button className={`accordion-button ${OpenItem === item.id ? '' : 'collapsed'}`} type="button" onClick={() => handleItemClick(item.id)}>
                            {item.title}
                        </button>
                    </h3>
                    <div id={`collapse${item.id}`} className={`accordion-collapse collapse ${OpenItem === item.id ? 'show' : ''}`} aria-labelledby={item.id}>
                        <div className="accordion-body">
                            <p>{item.content}</p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )

}

export default Accordion;